import {CandidateState, CandidateStateRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip} from "../../../../components/kit";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";

export const CandidateStateListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<CandidateState> = {
		title: "Estados para Contacto",
		onClick: "/app/admin/recruitment/candidatestate",
		headers: [
			{title: "Nombre"},
			{title: "Orden", align: "right"},
			{title: "Inicial"},
		],
		decorator: (bean: CandidateState) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{bean.name}
				</TableCell>
				<TableCell align="right">
					{bean.position}
				</TableCell>
				<TableCell>
					{bean.defaultState ? <SoftChip tone="info" label="Inicial"/> : ""}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(CandidateStateRestControllerApiFactory);
			return ctrl.pageCandidateState(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};